module.exports = __webpack_public_path__ + "files/CLEANHAND4.44ec775749a7a1d78e7b3afa95d9da2a.zip";